import React, { useEffect, useState } from 'react';
import './UnsubscribedTable.scss';
import {  Loader, TextButton } from 'cdk-radial';
import { useSelector } from 'react-redux';

const COLOR_STROKE = '#006CFA';
const LOADER_STYLE = {
  stroke: COLOR_STROKE,
  margin: '0px 35px',
  display: 'flex'
};
const ResubscribeSolution = (props) => {

  const { data } = props.gridParams;

  const {
    subscribedOn,
    solutionId,
    handleResubscribe,
    appName,
    method,
    solutionData
  } = data;

  const state = useSelector(state => state);
  const token = 
  state.loginDetailsSlice && state.loginDetailsSlice.authenticationToken;
  const planDetails = state.solutionInfoSlice.planDetails;

  const [fetchPlanDetails, setFetchPlanDetails] = useState(false);

  useEffect(()=>{
    if(planDetails.length){
      setFetchPlanDetails(false);
    }
  },[planDetails]);


  return (
    <>
      <span className="unsubscribed_subscribed-on">{subscribedOn}</span>
      {!solutionData?.isAppNotListed && (
        <span className="unsubscribe_button">
          {fetchPlanDetails ? (
            <Loader style={LOADER_STYLE} />
          ) : (
            <TextButton
              text={
                solutionData?.activateOnly !== false
                  ? 'Reactivate'
                  : 'Resubscribe'
              }
              onClick={() => {
                setFetchPlanDetails(true);
                handleResubscribe(solutionId, token, appName, method, solutionData?.activateOnly);
              }}
            />
          )}
        </span>
      )}
    </>
  );
}

export default ResubscribeSolution;